import React from "react";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";

import PlayerItemValueReadOnly from "./PlayerItemValueReadOnly";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
import { getDatasourceStateTreePathForRefId, retrieveDatasourceForRef } from "../../actions/datasource";
import GenericPicker from "./GenericPicker";
class PlayerPicker extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
		this.state = {
			speakValue: true,
			advanceOnSelectChangeMade: false
		};
	}

	onSubmit(forceNav=false) {
		this.doSubmit(this.props.item.value, this.state.pickerItem, forceNav);
	}

	onChangeSubmit(value, pickerItem, forceNav = false, speakValue=true) {
		let submittedValue = this.props.item.value;
		if (!_.isUndefined(value)) {
			submittedValue = value;
		}
		this.doSubmit(submittedValue, pickerItem, forceNav, speakValue);
	}

	doSubmit(value, pickerItem, forceNav = false, speakValue=true) {
			this.handleSubmitCallback(value, forceNav, this.state.speakValue && speakValue);
	}

	onClickDoneSubmit() {
		let item = this.props.item;

		if (item.pickerItemViewType === "buttons") {
				//with buttons done should advance forward and not link
			this.handleSubmitCallback(this.props.item.value, true, this.state.speakValue);
		} else {
			this.onSubmit(true);
		}
	}

	handleSubmitCallback(value, forceNav = false, speakValue = true) {
		if (this.props.onSubmit && _.isFunction(this.props.onSubmit)) {
			console.log("SUBMIT", value, forceNav, speakValue);
			const { listIndex, sectionIndex, itemIndex, identityId, disabled } = this.props;
			this.props.onSubmit({ value, listIndex, sectionIndex, itemIndex, identityId, disabled,forceNav,speakValue });
		}
	}

	handleOnChangeCallback(value) {
		if (this.props.onChange) {
			const { listIndex, sectionIndex, itemIndex, disabled } = this.props;
			this.props.onChange({ value, listIndex, sectionIndex, itemIndex, disabled, uncheckOnEmptyValue:true });
		}
	}

	onChange(value, pickerItem, speakValue=true) {

		let item = this.props.item;

		this.setState({
			pickerItem: pickerItem,
			speakValue
		});
		const preventAutoAdvance = value === null || value === "";
		//for buttons we submit immediately
		if (!preventAutoAdvance && ((item.hasOwnProperty("pickerAdvanceOnSelect") && item.pickerAdvanceOnSelect) ||
			(item.hasOwnProperty("pickerLinkOnSelect") && item.pickerLinkOnSelect === true) ||
			(!_.isUndefined(pickerItem) && pickerItem.hasOwnProperty("linking")))) {
			this.setState({
				advanceOnSelectChangeMade: true
			});

			this.onChangeSubmit(value, pickerItem, false, speakValue);
		} else {
			this.handleOnChangeCallback(value);
			// if (this.props.onChange) {
			// 	this.props.onChange(value, pickerItem);
			// }
		}
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	renderReadOnly() {
		return (
			<PlayerItemValueReadOnly item={this.props.item} />
		);
	}

	renderEditable() {
		const { item, getLabels, getImage, getVideo, getPdf, pickerItemsDatasourceResource, disabled } = this.props;

		let type;
		if (item.pickerItemViewType === "buttons") {
			type = "PlayerPickerButtons";
		} else if (item.pickerItemViewType === "dropdown-filter") {
			type = "PlayerPickerDropdownFilter";
		} else {
			type = "PlayerPickerSelect";
		}

		const pickerComponent = <GenericPicker type={type} item={item} onChange={this.onChange} pickerItemsDatasourceResource={pickerItemsDatasourceResource} disabled={disabled} />;

		let doneButton;
		if ((this.props.item.selected) && this.props.item.value !== null && this.props.item.value !== "" && (!item.hasOwnProperty("pickerAdvanceOnSelect") || !item.pickerAdvanceOnSelect || (this.props.item.value !== null && this.props.item.value !== "" && !this.state.advanceOnSelectChangeMade))) {
			doneButton = <DoneButton onSubmit={this.onClickDoneSubmit} />;
		}
		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ width: "100%", overflow: "visible" }}>
				{getLabels()}
				{getImage()}
				{getVideo()}
				{getPdf()}
				<div style={{ marginBottom: "16px" }}>
					{pickerComponent}
				</div>
				{doneButton}
			</div>
		</div>;
		return component;
	}

	componentDidMount() {
		const { item } = this.props;
		// console.log("Did mount", item);
		if (item && item.pickerItemsDatasource && !_.isEmpty(item.pickerItemsDatasource)) {
			// console.log("Going to retrieve and inject datasource");
			retrieveDatasourceForRef(item.pickerItemsDatasource);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.item.selected && (this.props.item.selected !== prevProps.item.selected)) {
			this.setState({
				speakValue: true,
				advanceOnSelectChangeMade: false
			});
		}
	}
}

export default branch((props) => {
	const branches = {};
	// self.props.listIndex, self.props.sectionIndex, self.props.itemIndex
	if (props.item && props.item.pickerItemsDatasource && !_.isEmpty(props.item.pickerItemsDatasource) && props.hasOwnProperty("listIndex") && props.hasOwnProperty("sectionIndex") && props.hasOwnProperty("itemIndex")) {
		// tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
		const path = getDatasourceStateTreePathForRefId(props.item.pickerItemsDatasource.refId);
		// console.log("Hooking up data source for branch", props.item.pickerItemsDatasource, path);
		if (path) {
			branches.pickerItemsDatasourceResource = path;
		}
	}

	return branches;
}, withPlayerItemHoc(PlayerPicker));